import { useEffect, useMemo, useRef } from 'react'

export function useTimeout () {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>()

  useEffect(() => {
    const timeout = timeoutRef.current

    return () => {
      if (timeout) clearTimeout(timeout)
    }
  })

  const timeout = useMemo(
    () => ({
      set: (callback: () => void, delay: number) => {
        timeoutRef.current = setTimeout(callback, delay)
      },
      clear: () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)
      },
    }),
    []
  )

  return timeout
}
